import React, { useState } from 'react';
import { LINKS } from '../brand';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const handleChange = (event) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const phoneNumber = '22377291138';
    const name = formData.name.slice(0, 80);
    const email = formData.email.slice(0, 120);
    const body = formData.message.slice(0, 1000);
    const message = `Bonjour, je suis ${name} (${email}).\n\n${body}`;
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
    setFormData({ name: '', email: '', message: '' });
  };

  return (
    <section id="contact" className="contact">
      <div className="container">
        <h2 className="section-title">Une question ?</h2>
        <p className="section-subtitle">
          Écrivez-nous : le message s’ouvre dans WhatsApp, sans compte à créer ici.
        </p>
        <div className="contact-content">
          <div className="contact-info">
            <div className="info-item">
              <h3>E-mail</h3>
              <p>
                <a href={LINKS.email} className="contact-link">
                  cheickm.sissoko@djammadev.com
                </a>
              </p>
            </div>
            <div className="info-item">
              <h3>Téléphone</h3>
              <p>
                <a href={LINKS.phone} className="contact-link">
                  +223 77 29 11 38
                </a>
              </p>
            </div>
            <div className="info-item">
              <h3>WhatsApp</h3>
              <p>
                <a
                  href={LINKS.whatsapp}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-link"
                >
                  +223 77 29 11 38
                </a>
              </p>
            </div>
          </div>
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Nom</label>
              <input
                type="text"
                id="name"
                name="name"
                autoComplete="name"
                value={formData.name}
                onChange={handleChange}
                maxLength="80"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">E-mail</label>
              <input
                type="email"
                id="email"
                name="email"
                autoComplete="email"
                value={formData.email}
                onChange={handleChange}
                maxLength="120"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows="5"
                maxLength="1000"
                required
              />
            </div>
            <button type="submit" className="btn btn-primary">
              Envoyer via WhatsApp
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
